import { get, post, put } from "../services/HttpService";
import { axiosIns } from "../services";
import { emailValidationRegex, beneficiaryNameRegex, phoneNumberValidationRegex } from "../app_methods";


export class VirtualAccount {
    constructor(virtualAccountObject = {}) {
        this.set(virtualAccountObject);
    };

    static validations = {
        "name": [
            { required: true, message: "Name is required." },
            { pattern: beneficiaryNameRegex(), message: "Please enter a valid name." },
            { max: 60, message: "Can be of maximum 60 characters" }

        ],
        "email": [
            { required: true, message: "Email ID is required." },
            { pattern: emailValidationRegex(), message: "Please enter a valid Email ID." }
        ],
        "phone": [
            { required: true, message: "Phone is required." },
            { pattern: phoneNumberValidationRegex(), message: "Phone number is invalid." }
        ],
        "narration": [
            { min: 2, message: "Description must be atleast 2 characters long." }
        ],
        "urn": [
            { required: true, message: "Unique Request Number is required" },
            { pattern: '^[A-Za-z0-9]+$', message: "Only alphanumeric values are allowed" },
            { max: 32, message: "Can be of maximum 32 characters" },
            { min: 5, message: "Should be at least 5 characters long" }
        ],
        "udf1": [
            { pattern: '^[^<>]*$', message: "Invalid value for UDF 1" },
            { max: 255, message: "Can be of maximum 255 characters" }
        ],
        "udf2": [
            { pattern: '^[^<>]*$', message: "Invalid value for UDF 2" },
            { max: 255, message: "Can be of maximum 255 characters" }
        ],
        "udf3": [
            { pattern: '^[^<>]*$', message: "Invalid value for UDF 3" },
            { max: 255, message: "Can be of maximum 255 characters" }
        ],
        "udf4": [
            { pattern: '^[^<>]*$', message: "Invalid value for UDF 4" },
            { max: 255, message: "Can be of maximum 255 characters" }
        ],
        "udf5": [
            { pattern: '^[^<>]*$', message: "Invalid value for UDF 5" },
            { max: 255, message: "Can be of maximum 255 characters" }
        ],
    };

    /**
     * @memberof VirtualAccount
     * @type API
     * @returns Promise
     */
    static list = (queryData = {}, config = {}) => {
        return get(`v1/insta-collect/internal/virtual_accounts/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }));
    };

    static list_v2 = (queryData = {}, config = {}) => {
        return get(`v2/insta-collect/internal/virtual_accounts/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }));
    };

    static listSearch = (queryData = {}, config = {}) => {
        return get(`v1/insta-collect/internal/search_virtual_accounts/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }));
    }

    static virtual_account_list = (queryData = {}, config = {}) => {
        return get(`v1/insta-collect/internal/master_virtual_accounts/`, queryData, config).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }));
    };

    static generate_cva_urn = (queryData = {}, config = {}) => {
        return post(`v1/insta-collect/internal/virtual_accounts/generate_urn/`, queryData, config);
    }

    /**
     * @memberof VirtualAccount
     * @type API
     * @returns Promise
     */
     save = () => {
        let queryData = this.get();
        if (queryData.id) return put(`v1/insta-collect/internal/virtual_accounts/${this.id}/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
        return post(`v1/insta-collect/internal/virtual_accounts/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    /**
     * @memberof VirtualAccount
     * @type API
     * @returns Promise
     */

     retrieve = (queryData = {}) => {
        return get(`v1/insta-collect/internal/virtual_accounts/${this.id}/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
     };

     update_status = (queryData) => {
         return post(`v1/insta-collect/internal/virtual_accounts/${this.id}/update_status/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
     }

     send_collect_request = (queryData) => {
         return post(`v1/smart-collect/internal/virtual_accounts/${this.id}/send_collect_request/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
     }

     get_insights = (queryData) => {
        return get(`v1/insta-collect/internal/virtual_accounts/${this.id}/insights/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    get_scanner_link = (queryData) => {
        return get(`v1/insta-collect/internal/virtual_accounts/${this.id}/upi/scanner/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    static report_download = (queryData = {}, config = {}) => {
        return axiosIns.request({
            url: 'v1/insta-collect/internal/virtual_accounts/report_download/',
            method: 'POST',
            responseType: 'blob',
            data: queryData,
            headers: config.headers
        }).catch(error => ({ success: false, data: "Something went wrong", status: 500 }))
    }

    get_kyc_data = (queryData) => {
        return get(`v1/insta-collect/internal/virtual_accounts/${this.id}/kyc/get_data/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    get_cva_configuration_details = (queryData) => {
        return post(`v1/insta-collect/internal/split_accounts/custom_virtual_accounts/${queryData?.id}/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    /**
     * @memberof VirtualAccount
     * @type Getter Method
     * @takes void
     * @returns VirtualAccount Params
     */
    get = () => {
        return {
            id: this.id,
            label: this.label,
            virtual_account_number: this.virtual_account_number,
            virtual_ifsc_number: this.virtual_ifsc_number,
            virtual_upi_handle: this.virtual_upi_handle,
            is_active: this.is_active,
            description: this.description,
            auto_deactivate_at: this.auto_deactivate_at,
            authorized_remitters: this.authorized_remitters,
            upi_qrcode_url: this.upi_qrcode_url,
            virtual_account_number: this.virtual_account_number,
            virtual_payment_address: this.virtual_payment_address,
            kyc_flow: this.kyc_flow,
            phone_numbers: this.phone_numbers,
            transaction_amount_limit: this.transaction_amount_limit,
            unique_request_number: this.unique_request_number,
            udf1: this.udf1,
            udf2: this.udf2,
            udf3: this.udf3,
            udf4: this.udf4,
            udf5: this.udf5,
        }
    };

    /**
     * @memberof VirtualAccount
     * @type Setter Method
     * @takes VirtualAccount Params
     * @returns void
     */
    set = (values) => {
        Object.keys(values).forEach(x => this[x] = values[x]);
    };

    /**
     * @memberof VirtualAccount
     * @type Setter Method
     * @takes VirtualAccount Params
     * @returns void
     */
    reset = () => {
        this.id = undefined;
        this.label = undefined;
        this.virtual_account_number = undefined;
        this.virtual_ifsc_number = undefined;
        this.virtual_upi_handle = undefined;
        this.is_active = undefined;
        this.description = undefined;
        this.auto_deactivate_at = undefined;
        this.authorized_remitters = undefined;
        this.upi_qrcode_url = undefined;
        this.kyc_flow = false;
        this.phone_numbers = undefined;
    };

}